import TERMS_AND_PRIVACY_URLS from '../utils/constants/termsAndPrivacyUrls'

const en = {
  ra: {
    notification: {
      genericError: 'Something went wrong',
      loginError: 'Something went wrong, please try again',
      deleteSuccess: 'Deleted Successfully',
      deleteError: 'An error occurred during deletion',
      created: 'Created Successfully',
      updated: 'Updated Successfully',
      updatedError: 'An error occurred during updating',
      item_doesnt_exist: "Item doesn't exists",
      noNotifications: 'No Notifications.',
      invitation: 'Invitation',
      billing: 'Billing',
      serverError: 'Unable to load notifications.',
    },
    invitation: {
      pending: 'invited you to join organisation',
    },
    billing: {
      warning: 'Your billing period is ending in: ',
      ended: 'Your billing period has expired.',
    },
    validationErrors: {
      inValidEmail: 'Please insert a valid e-mail',
      password: 'Must be at least 8 characters.',
      confirmPassword: 'Passwords must match',
      terms: 'Accept Terms & Conditions is required',
      requiredField: 'Required field',
      fromDate: "The start date of a livestream event can't be in the past",
      startTime: "The start time of a livestream event can't be in the past",
      endTime: "The end time of a livestream event can't be less than 30 minutes.",
      courtId: 'When creating livestream event, court is required.',
      threeLetter: 'The name identifier must be 3 letters.',
    },
    message: {
      invalid_form: 'INVALID FORM',
      not_found: 'The page you requested does not exist',
    },
    auth: {
      logout: 'Log Out',
      auth_check_error: 'Authorization Error',
    },
    page: {
      dashboard: 'Dashboard',
      login: 'Log In',
      signUp: 'Sign Up',
      terms: 'Terms and Conditions',
      forgotPassword: 'Forgot Password',
      resetPassword: 'Reset Password',
      profile: 'Profile',
      orgSettings: "Organisation's Settings",
      security: 'Security',
      preferences: 'Preferences',
      edit: 'EDIT',
      list: 'LIST',
      create: 'CREATE',
      not_found: 'Page not found',
      show: 'SHOW',
      subscription: 'OVERVIEW',
      payments: 'PAYMENT HISTORY',
      billingDetails: 'BILLING DETAILS',
      distribution: 'Distribution',
    },
    text: {
      team: 'Team ',
      teamsOfThree: 'Teams of Three',
      teamsOfFour: 'Teams of Four',
      teamsOfFive: 'Teams of Five',
      players: 'PLAYERS',
      playersSmall: 'Players',
      selectedPlayers: 'Players',
      downloadRecording: 'Get Recording',
      notMobileOptimised: 'This page is not yet optimised for Mobile.',
      tryDesktop: 'Give it a try on a Desktop or Tablet!',
      invitedBy: 'invited by %{name}',
      nothingPlanned: 'Nothing planned',
      nothingPlannedIn: 'Nothing planned in %{month}',
      noPendingInvitations: 'You have no pending invitations.',
      mobileAvailablePages: 'On your phone you can view the Calendar and manage your Profile.',
      emailConfirm: 'Please press the button to confirm your email',
      createOrg: 'Create your first organisation',
      orgAvatar: 'Club Logo',
      deleteEventPrompt: 'Delete this event?',
      description: 'Description',
      publish: 'Publish',
      tags: 'Tags',
      viewMore: 'VIEW MORE',
      backToOrg: 'Back to Organisation',
      text: 'Text',
      createNew: 'Create New',
      minutes: 'Minutes',
      activity: 'Activity',
      notes: 'Notes',
      min: 'min',
      changeEmail: 'Change your e-mail',
      insertNewEmail: 'Insert the new email and your password',
      changePhoneNumber: 'Change your Phone number',
      insertNewPhoneNumber: 'Insert the new phone number and your password',
      disableAccount: 'Are you sure you want to delete your account?',
      insertPassword: 'Insert your password to delete your account',
      closeAccount: 'Delete account',
      disableAccountDataLost: 'If you delete your account, all your data will be lost.',
      deleteOrg: 'Are you sure you want to delete your organisation?',
      deleteOrgName: 'Please write the name of the organisation you wish to delete',
      deleteTeam: 'Are you sure you want to delete your team?',
      deleteTeamName: 'Please write the name of the team you wish to delete',
      pendingEmail: 'Pending email(s)',
      forgotPassword: 'Please enter your email to receive a reset password link',
      noCurrentTeams: 'There are no teams available',
      graphics: 'Graphics',
      courts: 'Courts',
      courtsList: 'List of your courts',
      orgUsersList: 'Manage people and invitations',
      invitationsList: 'List of your pending invitations',
      signUpInvitedEmailLocked: 'This is the address your invitation was sent to.',
      emptyCourts: 'No courts available',
      emailSent: 'A verification mail has been sent to your account!',
      confirmingEmail: 'Confirming your email address...',
      deleteOrgInfo:
        "By closing the organisation you would delete all it's teams and it's members.",
      passOwnershipInfo:
        'By passing ownership of the organisation you would pass all rights of user editing and billing to another member of the organisation.',
      passOwnershipSuccess: 'Your request was sent. Now you should wait the user to accept it.',
      managePlayers: "Manage your team's members",
      stopLivestream: 'Are you sure you want to stop running livestream?',
      startLivestream: 'Are you sure you want to start the livestream?',
      oneStreamLive: '1 stream live',
      streamsLive: '%{count} streams live',
      startingStream: 'Starting stream…',
      stoppingStream: 'Stopping stream…',
      stopThisStream: 'Stop this stream?',
      broadcasting: 'Broadcasting',
      recordingOnly: 'Recording only',
      addTeamText: 'Add Team',
      recent: 'RECENT',
      teamSettings: "Team's Settings",
      manageOrgTeams: "Manage your organisation's teams, their information and categories",
      noRecentLivestream: 'There are no recent livestreams!',
      inviteUsers: 'Invite Users',
      setRoles: 'Set Roles',
      deleteOrgUser: 'Are you sure you want to remove this user from the organisation?',
      deleteInvitationConfirmation: 'Are you sure you want to reject the invitation from ',
      passOwnership: 'Pass Ownership of the organisation',
      paymentSuccess: 'Payment success',
      changeCardSuccess: 'Card change success',
      paymentFail: 'Payment Failed',
      changeCardFail: 'Card change fail',
      addingNewUser: 'Adding new user?',
      addingNewUserText:
        'Inviting users is free and there is no limit on how many you can invite.',
      removingUser: 'Removing user?',
      removingUserText:
        'Removing a user has no effect on your bill.',
      getInvoice: 'How do I get my invoice?',
      getInvoiceText:
        'If you have added all the details needed, you will get your invoice in 24 hours via email.',
      contactYou: 'How do I contact you?',
      contactYouText:
        'For any info regarding billing and subscription contact us at accounting@mismatch.gr',
      orgSubscription: 'Add-ons',
      activateOrgSubscription: 'Your Addons',
      faq: 'Frequently Asked Questions',
      subscriptionSummary: 'Billing Summary',
      outstanding: 'outstanding',
      outstandingCharges: 'Outstanding Charges',
      outstandingChargesDescription: 'You have unpaid charges from a previous billing period.',
      outstandingTotal: 'Outstanding Total',
      reActivateOrgSubscription: 'Re-activate your Organisation’s subscription',
      subscription: 'Subscription',
      monthly: 'Monthly',
      noTransactions: 'You have not made any payments.',
      addANote: 'Add a note',
      orgMembers: 'ORGANISATION MEMBERS',
      scoreboardSourceInfo:
        'Where the score shown on the stream comes from. Only the sources this court and stream plan can feed are listed.',
      gameStateTrackingInfo:
        'The following field controls the event detection of your stream. You can set the event detection to automatic, control it yourself through the stream app or disable it.',
      uploadVideoInfo:
        'Videos should be short enough to fit in breaks and their file size should not exceed 20Mb.',
      stillUploading:
        'You still have video uploading in progress, if you want to create the event your videos wont be saved!',
      completed: 'Completed',
      addTeamFirst: 'You need to add a team first!',
      youHave: 'You have ',
      pendingInvitation: ' pending invitation',
      emptyCourtsList: 'No courts have been created yet!',
      noOptionsAvailable: 'No options available',
      createNewCourt: 'Create new court',
      inviteByEmail: 'Or invite by email:',
      ownershipRequested: 'You have requested ',
      toBecomeOwner: ' to become organisation Owner.',
      invitations: 'Invitations',
      OrgUsers: 'Organisation Users',
      apps: 'Apps',
      integrations: 'Integrations',
      manageIntegrations: 'Manage your integrations',
      widgets: 'Widgets',
      widgetsSubtitle:
        'Embed live stats on your website. Copy a snippet below and paste it into your page.',
      widgetsDocsLink: 'View full widget documentation.',
      widgetsRequireStats: 'Widgets are only available if the Stats addon is enabled.',
      competitionWidget: 'Competition',
      boxscoreWidget: 'Boxscore',
      competitionLiveScoreWidget: 'Competition Live Score',
      copy: 'Copy',
      copied: 'Copied!',
      youtubeIntegrationText:
        "You can associate your organisation with YouTube channel to streamline your livestream setups. This integration automatically sets up the YouTube broadcast event so that you don't have to do it yourself.",
      youtubeIntegrationInfo: `(App’s) use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank">Google API Services User Data Policy</a>, including the Limited Use requirements.`,
      linkYoutubeChannel: 'Link YouTube channel',
      youtubeReconnectRequired:
        'YouTube has stopped accepting this connection. Reconnect the channel to keep broadcasting to it.',
      youtubeReconnectRequiredForBroadcast:
        'Your YouTube channel is unavailable as a destination because the connection has expired.',
      reconnectOnIntegrations: 'Reconnect it on the Integrations page',
      unlink: 'Unlink',
      contentChildren: 'Content appropriate for kids:',
      promotionalContent: 'Contains promotional content',
      liveChat: 'Live Chat',
      liveChatReplay: 'Live Chat Replay',
      liveChatParticipants: 'Live Chat Participants',
      liveChatReactions: 'Live Chat Reactions',
      useYoutube: "Use the organisation's YouTube channel",
      differentYoutubeChannel: 'Use stream key URI',
      youtubeChannelTab: 'Your YouTube',
      streamKeyTab: 'Custom RTMP',
      enterThumbnail: 'Upload Video Thumbnail',
      thumbnailEdit: 'The thumbnail image should not exceed 2MB',
      enableStats: 'Enable Stats',
      autofollowEnabled: 'Autofollow',
      streamNotStarted: 'The stream has not started yet. Please wait.',
      profileSettingsSub: 'Manage your personal information',
      removeVideo: 'Are you sure you want to remove this video from the training module?',
      bigFileAdded: 'The file is bigger than 20Mb',
      billingDetails: 'Billing Details',
      needInvoice: 'Are you a company? Need Invoice?',
      orgOwner:
        'You are the organisation owner. Deleting your account will result in the deletion of all organisations you own.',
      cancelSubscriptionConfirmation: 'Are you sure you want to cancel your subscription?',
      period: 'Period',
      quarter: 'Q',
      youAreAdding: 'You are adding',
      at: 'at',
      month: 'month',
      unauthorizedPageHeader: "Looks like you've been benched, let's get you back in the game!",
      unauthorizedPageMain:
        'Contact the organisation owner and check your subscription status or contact us.',
      unauthorizedPaymentHeader: 'One step left — make your first payment to get started.',
      unauthorizedPaymentMain:
        'Your organisation is set up and its price is agreed. Complete your subscription to make the first payment and unlock everything.',
      cardSavedSubscribe: 'Card saved — click Subscribe to activate your subscription',
      unauthorizedTooltip: "You don't have access to this page. Check organisation's subscription!",
      supportBubbleHeader: 'Facing Issues?',
      supportBubbleText: 'Ask us anything or inform us for possible problems you encounter!',
      jerseyNumber: 'Jersey number: ',
      height: 'Height: ',
      positions: 'Positions: ',
      games: 'Games: ',
      allGames: 'All Games',
      lastGame: 'Last Game',
      last5Games: 'Last 5 Games',
      last10Games: 'Last 10 Games',
      seasonStats: ' Season Stats',
      gameStats: 'Game Stats',
      stats: 'Stats',
      navGames: 'Games',
      won: 'Won',
      lost: 'Lost',
      PIR: "Performance Index Rating, a measure of a player's overall statistical performance",
      GP: 'Games Played',
      GS: 'Games Started',
      MIN: 'Minutes Played',
      PTS: 'Points',
      '2P': 'Two-point Field Goal',
      '3P': 'Three-point Field Goal',
      FT: 'Free Throw',
      OR: 'Offensive Rebounds',
      DR: 'Defensive Rebounds',
      TR: 'Total Rebounds',
      AST: 'Assists',
      STL: 'Steals',
      TO: 'Turnovers',
      BLK: 'Blocks',
      BLKA: 'Blocks Against',
      FC: 'Fouls Committed',
      FD: 'Fouls Drawn',
      perQuarter: 'Per Quarter',
      endOfQuarter: 'End Of Quarter',
      addonDes: 'Description',
      totalCost: 'Total Cost',
      nextBillingDate: 'Next Payment Due',
      videoActivation: 'Video Activation',
      videoActivationMessage: 'You can ask everything you want to know about streaming videos.',
      updateSubscriptionConfirmation: 'You are about to update your subscription.',
      noActiveAddons:
        'You are about to remove the last addon from your subscription. Since this is the last addon, your subscription will be canceled until you activate it again.',
      addOnActivation: 'Add-on Activation',
      addonType: 'Addon',
      billingReadOnly:
        'Your billing information can only be changed by Mismatch. Contact support@mismatch.gr for any change other than your card details.',
      billingIncompleteForCheckout:
        'Your billing information is incomplete, so this purchase cannot be completed. Contact support@mismatch.gr to have it filled in.',
      billingPaymentMessage:
        'Having an active subscription will lead you to pay only for the remaining month to activate this addon.',
      billingPaymentMessageInvite:
        'Having an active subscription will lead you to pay only for the remaining month to invite users.',
      reactivate: 'REACTIVATE',
      activateCoupon: 'ACTIVATE COUPON',
      publishTextA: 'Please ensure all fields are filled and the ',
      publishTextB: ' is written in English.',
      publishTextC:
        'Mismatch reserves the right to modify or unpublish your component if necessary.',
      mainSubText: 'Re-subscribe to get access to activated addons.',
      totalPrice: 'Total price',
      socialConfMvp: 'Post Game MVP',
      socialConfAnnouncement: 'Post Game Announcement',
      socialConfQuarter: 'Post Game Quarter Announcement',
      socialConfResult: 'Post Game Result Announcement',
      socialConfBackground: "Post's background image",
      noAccounts: 'No Accounts Found',
      share: 'Share',
      copyToClipBoard: 'URL copied to clipboard!',
      didNotPlay: 'Did Not Play',
      score: 'Live Score',
      upcoming: 'Upcoming',
      final: 'Final Score',
      postponed: 'Postponed',
      forfeit: 'Forfeit',
      continueWithFB: 'Continue with Facebook',
      metaConnected: 'Connected: %{platforms}',
      metaIntegrationText:
        'You can connect your organisation with you Facebook account to automate the posting on your Facebook and Instagram feed. For every game you create, you get posts for game announcement, game mvp, game result and quarter result!',
      emailNotification:
        'Your recording is getting ready. You will receive an email with the download link, soon.',
      gameSummaryNotification:
        'Your game summary is getting ready. You will receive an email to download it.',
      downloadSummary: 'Get Summary',
      overlayLinks: 'Get Overlay Links',
      fansConfig: 'Fans Configuration',
      isFansEnabled: 'Is Fans Enabled',
      fansChannels: 'Competition channels',
      fansChannelsHint:
        'Enable or disable the Fans channel for each competition. Changes save automatically.',
      competition: 'Competition',
      fansEnabled: 'Fans enabled',
      noCompetitions: 'No competitions yet. Create a competition to enable a Fans channel for it.',
      integrationRequiresAddon: 'Integration requires addon %{addon} to be enabled',
      socialChannelsHint:
        'Connect a Meta (Facebook / Instagram) account per competition. PicknPost publishes to the connected account.',
      metaAccount: 'Meta account',
      connect: 'Connect',
      chooseAccountToConnect: 'Choose an account to connect with!',
      noSocialCompetitions:
        'No competitions yet. Create a competition to connect a social account for it.',
      noOrgTitle: 'Your account is not associated with any organisation',
      noOrgContact: 'For more information contact Mismatch at',
      noOrgAppsTitle: 'Want to see statistics? Download our app GameDay',
      noOrgGamedayComment: 'Follow games, live scores, stats and play-by-play from your phone.',
    },
    formFields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phoneNumber: 'Phone Number',
      password: 'Password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      birthday: 'Birth Date',
      acceptTerms: `<span style="color: #E0726E; font-weight: 700">* </span>I have read and agreed to <a style="color: #E0726E" href="${TERMS_AND_PRIVACY_URLS.TERMS_OF_USE}" target="_blank">Term of Services</a> and <a style="color: #E0726E" href="${TERMS_AND_PRIVACY_URLS.PRIVACY_POLICY}" target="_blank">Privacy Notice</a>`,
      marketingConsent:
        'I consent to receiving promotional emails, newsletters, and marketing communications from Mismatch. (optional)',
      dataSharingConsent:
        'I consent to Mismatch sharing my contact details and usage data (such as email address, favorite teams, in-app interactions, and engagement metrics) with selected third-party partners for marketing, advertising, and other commercial purposes. (optional)',
      name: 'Name',
      country: 'Country',
      city: 'City',
      logo: 'Logo',
      ageGroup: 'Select Age Group',
      gender: 'Select Gender',
      shortName: 'Short Name',
      teamShortName: 'Team Short Name',
      teamName: 'Team Name',
      teamExternalId: 'Team External Id',
      eventTitle: "Event's Title",
      from: 'From',
      date: 'Date',
      to: 'To',
      notes: 'Notes',
      topic: 'Topic',
      place: 'Place',
      startTime: 'Start Time',
      endTime: 'End Time',
      location: 'Location',
      opponent: 'Opponent',
      home: 'Home',
      away: 'Away',
      neutral: 'Neutral',
      court: 'Court',
      gym: 'Gym',
      other: 'Other',
      team: 'Team',
      teams: 'Teams',
      role: 'Role',
      intensity: 'Intensity',
      positions: 'Positions',
      title: 'Title',
      courtName: 'Court Name',
      homeTeam: 'Home Team',
      awayTeam: 'Away Team',
      streamKey: 'Stream key',
      streamKeyPlaceholder: 'Paste your stream key',
      customServerPlaceholder: 'rtmp://your-server/app/stream-key',
      streamKeyURI: 'RTMP URL',
      streamKeyURI2: 'Extra RTMP URL',
      addAdditionalStreamKey: 'Add extra stream key URI',
      youtubeVideoTitle: 'Title',
      youtubeVisibility: 'Visibility',
      externalBroadcastUrl: 'External stream link',
      seasonName: 'Season Name',
      statsMode: 'Stats Mode',
      OrgRole: 'Organisation Role',
      userPermissions: 'User Permissions',
      streamVideo: 'Livestream',
      recordVideo: 'Record-Only',
      livestreamType: 'Type',
      panoramic: 'Panoramic',
      gameLite: 'Game Lite',
      gameFull: 'Game Full',
    },
    gameDrawer: {
      title: 'Game',
      requiredFields: 'Required fields',
      statistician: 'Statistician',
      studioOperator: 'Studio operator',
      videoOperator: 'Video operators',
      sharedRevenue: 'Shared revenue',
      team: 'Team',
      tabs: {
        details: 'Details',
        streaming: 'Streaming',
        stats: 'Stats',
      },
      sections: {
        matchup: 'Teams',
        destination: 'Destination',
        automation: 'Automation',
        production: 'Production',
        ads: 'Ads',
      },
      coverage: {
        off: 'Off',
        recordOnly: 'Record only',
        livestream: 'Livestream',
      },
      offNote: "This game won't be streamed or recorded.",
      noStreamCourt: 'Select a court configured for streaming to set up coverage for this game.',
      thirdPartyStreamPrompt: 'Streaming via a 3rd party provider?',
      automation: {
        autoStart: 'Auto-Start',
        autoStop: 'Auto-Stop',
        autoStartDesc: 'Go live at the scheduled start time.',
        autoStopDesc: 'End the stream at the scheduled finish.',
      },
      addStreamKey: 'Add RTMP URL',
      streamToCustomServer: 'Stream to a custom server',
      useYoutube: 'Use YouTube server',
      scoreboardSource: 'Scoreboard',
      commentary: {
        label: 'Commentary',
        offSite: 'Off-site',
        onSite: 'On-site',
        viaCamera: 'Via camera',
        info: 'Off-site: commentated from the web Studio, from anywhere. On-site: commentated at the court, optionally with a mic plugged into the camera.',
      },
      streamEventTracking: 'Event tracking',
      streamEventTrackingDesc: 'Manually tag events during the stream.',
      stats: {
        trackStats: 'Track Stats',
        trackStatsDesc: 'Unlocks status & live stat entry.',
        lockedNote: 'Enable Track Stats to assign a statistician.',
      },
      result: {
        section: 'Result',
        noResult: 'No result recorded',
        final: 'Final score %{score}',
        live: 'Live %{score}',
        forfeitBy: 'Forfeit: %{team} (%{reason})',
        setScore: 'Set score',
        forfeit: 'Forfeit',
        saveScore: 'Save score',
        recordForfeit: 'Record forfeit',
        keepStats: 'Keep recorded player statistics',
        keepStatsDesc:
          'If off, all recorded statistics of this game (play-by-play, player and team stats) are deleted permanently.',
        forfeitingTeam: 'Forfeiting team',
        reason: 'Reason',
        reasonStandard: 'No-show (20-0)',
        reasonLessThan2Players: 'Fewer than two players (2-0)',
        scoreAtStop: 'Score when the game was stopped (optional)',
        scoreAtStopHint: 'If the opponent was ahead, the recorded score stands.',
        confirmScoreTitle: 'Set final score?',
        confirmScoreText:
          'The final score will be set to %{score} and the game will be closed. Team statistics and standings will be recalculated.',
        confirmReplaceTitle: 'Replace recorded statistics?',
        confirmReplaceText:
          'All recorded statistics of this game (play-by-play, player and team stats) will be permanently deleted and replaced by the score %{score}. This action cannot be undone.',
        confirmReplaceAgainTitle: 'Are you sure?',
        confirmReplaceAgainText:
          'Deleted statistics cannot be recovered. This action cannot be undone.',
        confirmForfeitTitle: 'Record forfeit?',
        confirmForfeitText:
          'A forfeit by %{team} (%{reason}) will be recorded and the game will be closed. Team statistics and standings will be recalculated.',
        continue: 'Continue',
        confirm: 'Confirm',
        deleteAndReplace: 'Delete & replace',
        saved: 'Result saved',
        invalidScore: 'Enter a valid score for both teams',
        selectTeam: 'Select the forfeiting team',
        bothScoresOrNone: 'Fill in the score for both teams or leave both empty',
      },
    },
    consentPopup: {
      title: 'Updated Terms of Use',
      subtitle: 'Please review and accept to continue using Mismatch.',
      required: 'REQUIRED',
      optional: 'OPTIONAL',
      acceptTermsPrefix: 'I have read and agree to the',
      termsOfUse: 'Terms of Use',
      and: 'and the',
      privacyPolicy: 'Privacy Policy',
      marketingConsent:
        'I consent to receiving promotional emails, newsletters, and marketing communications from Mismatch.',
      dataSharingConsent:
        'I consent to Mismatch sharing my contact details and usage data (such as email address, favorite teams, in-app interactions, and engagement metrics) with selected third-party partners for marketing, advertising, and other commercial purposes.',
      save: 'Save',
    },
    invitationLanding: {
      invitedAs: '%{sender} invited you to join as %{role}.',
      invitedToOwn: '%{sender} invited you to take over this organisation.',
      logInToAnswer: 'Log in to answer',
      createAccountFor: 'Create your Mismatch account with %{email} to answer.',
      createAccount: 'Create account',
      otherAccount:
        'This invitation was sent to %{receiver}, but you are logged in as %{current}.',
      logOutAndContinue: 'Log out and continue',
      unavailableTitle: 'Invitation unavailable',
      unavailable:
        'This invitation has already been answered or was withdrawn. Ask the sender for a new one if you still need access.',
    },
    kickoffContract: {
      title: 'Organisation agreement',
      subtitle:
        'Before you take over this organisation, please read the agreement below and accept it.',
      openDocument: 'Open the agreement',
      openInNewTab: 'Open the agreement in a new tab',
      acknowledge: 'I have read the agreement and accept its terms',
      accept: 'Accept',
      versionChanged:
        'The agreement was updated while you were reading it, so your acceptance was not recorded. The current version is shown above — please read it and accept again.',
    },
    existingOrgContract: {
      subtitle:
        'Your organisation has been asked to sign the Mismatch agreement. Please read it below and accept to continue.',
    },
    buttons: {
      goToCalendar: 'Calendar',
      goToProfile: 'Profile',
      average: 'Average',
      accumulate: 'Accumulate',
      login: 'LOG IN',
      signUp: 'SIGN UP',
      submit: 'SUBMIT',
      reset: 'RESET',
      update: 'UPDATE',
      save: 'SAVE',
      change: 'CHANGE',
      disableAccount: 'DELETE ACCOUNT',
      disable: 'DISABLE',
      add: 'ADD',
      addSmall: 'Add',
      upload: 'UPLOAD',
      uploadImage: 'UPLOAD IMAGE',
      create: 'CREATE',
      createSmall: 'Create',
      newEvent: 'New Event',
      createAndNew: 'CREATE AND NEW',
      addPlayer: 'Add Player',
      invite: 'INVITE',
      addSeason: 'Add Season',
      addTeam: 'Add Team',
      addRole: 'Add Role',
      editPlayer: 'EDIT PLAYER',
      delete: 'DELETE',
      cancel: 'CANCEL',
      keep: 'Keep',
      selectTeam: 'Select Team',
      public: 'PUBLIC',
      personal: 'PERSONAL',
      edit: 'Edit',
      showSmall: 'Show',
      hideSmall: 'Hide',
      pauseSmall: 'Pause',
      resumeSmall: 'Resume',
      stopSmall: 'Stop',
      cancelSmall: 'Cancel',
      stopStream: 'Stop stream',
      close: 'CLOSE',
      remove: 'REMOVE',
      removeSmall: 'Remove',
      resend: 'RESEND',
      redirectLogin: 'Redirect to Login',
      resendMail: 'Resend e-mail',
      chooseFile: 'CHOOSE A FILE',
      uploadSeasonLogo: 'SEASON LOGO',
      uploadTeamLogo: 'TEAM LOGO',
      loadRecentSetups: 'Reuse Setup',
      select: 'SELECT',
      stop: 'STOP',
      skip: 'SKIP',
      passOwnership: 'PASS OWNERSHIP',
      cancelRequest: 'CANCEL REQUEST',
      request: 'REQUEST',
      accept: 'ACCEPT',
      reject: 'REJECT',
      continue: 'CONTINUE',
      tryAgain: 'TRY AGAIN',
      retry: 'RETRY',
      changeCard: 'CHANGE CARD',
      addCard: 'ADD CARD',
      addToPersonal: 'ADD TO PERSONAL',
      addToPersonalLower: 'Add to personal',
      newPractice: 'New Practice',
      export: 'Export',
      watchStream: 'WATCH STREAM',
      watchVideo: 'Watch Video',
      startVideo: 'Start Livestream',
      exit: 'EXIT',
      play: 'PLAY',
      pause: 'PAUSE',
      none: 'NONE',
      removeVideo: 'REMOVE VIDEO',
      cancelSubscription: 'CANCEL SUBSCRIPTION',
      no: 'NO',
      subscribe: 'SUBSCRIBE',
      completeSubscription: 'Complete subscription',
      activate: 'ACTIVATE',
      contactUs: 'CONTACT US',
      next: 'NEXT',
      payNow: 'PAY NOW',
      fans: 'FANS',
      social: 'SOCIAL',
      disconnect: 'Disconnect',
    },
    gridLinks: {
      login: 'Back to Log In',
      signUp: "Don't have an account? Sign Up",
      forgotPassword: 'Forgot password?',
    },
    errorMessages: {
      unknown: '',
      unauthorized: '',
      forbidden: '',
      invalidData: 'You must complete all the required fields.',
      serviceUnavailable: '',
      badRequest: '',
      s2sConflict: 'Sorry, the email or phone number is already in use.',
      businessError: 'Business Error',
      accountNotFound: 'Sorry, your account does not exist.',
      wrongPassword: 'Sorry, your account does not exist or your password is wrong.',
      emailAccountNotConfirmed: 'Sorry, your email account is not confirmed.',
      passwordResetTimeExpired: 'Sorry, password reset time has expired.',
      passwordNotFound: '',
      tokenNotValid: 'Invalid Token',
      tokenHasBeenUsed: 'Token has been used',
      identityNotFound: '',
      identityAlreadyConfirmed: '',
      identityIsPrimary: '',
      usernameExists: '',
      confirmEmailError: 'Your email has not been confirmed',
      confirmEmailErrorRedirect: 'Redirecting to resend confirmation email page in',
      emailResentError: 'Resending verification mail failed. Try again!',
      emailResetPasswordError:
        'We could not find an account associated with the email address you provided. Please check the email address and try again. If you believe this is an error, please contact us at support@mismatch.gr.',
      logosLargePayloadError: 'Sorry, images exceed the uploaded limit of 16mb.',
      resetPasswordLinkExpired:
        'This link has expired or has already been used — request a new one from the Forgot Password page.',
      passwordBreached:
        'This password has appeared in a known data breach. Please choose a different one.',
      resetPasswordError: 'Password reset failed. Please try again.',
      // Livestream schedule validation — text must match the backend ValidationException messages
      // (EventService.ValidateScheduledStreamUpdate) so the toast can be localized.
      autoStartPastStart: "Auto-start can't be enabled when the start time is in the past.",
      startPastAutoStartOn: "The start time can't be in the past while auto-start is enabled.",
      autoStopPastEnd: "Auto-stop can't be enabled when the end time is in the past.",
      endPastAutoStopOn: "The end time can't be in the past while auto-stop is enabled.",
      livestreamMinDuration: 'A livestream must be at least 30 minutes long.',
      serverError: 'Something went wrong. Please try again.',
      changePasswordError: 'Changing password failed.',
      updateTeamError: 'Update team failed. Please try again!',
      signUpError: 'Sorry, something went wrong!',
      selfInviteError: 'You cannot add your own email!',
      noUsersToInviteError: 'No users where added to invite!',
      doubleInviteError: 'You cannot add the same email twice!',
      alreadyOrganisationUserError:
        'The user is already an organisation user or you have already sent an invitation!',
      wrongEmailFormat: 'Wrong email input!',
      invitationSendError: 'Error while sending invitation!',
      invitationRejected: 'Invitation rejected!',
      maxVideosAdded: 'Cannot add more videos!',
      sameVideosAdded: 'Cannot add the same video!',
      wrong: 'Wrong password!',
      errorMessages: 'Something went wrong',
      connectionError: 'An error occured while loading data.',
      supportMessageFail: 'Support message sent unsuccessfully!',
      noStatsAvailable: 'No stats available.',
      noGamesAvailable: 'No Games available.',
      statsGameNotStarted: 'The game has not started yet.',
    },
    successMessages: {
      accountCreatedLogIn: 'Your account is ready. Log in to answer your invitation.',
      forgotPassword: 'An email with instructions is sent.',
      resetPassword: 'Your password has been changed, you will be redirected to Log In Page.',
      emailConfirm: 'Your email is confirmed, you will be redirected to Log In Page.',
      signUp: 'Your account has been created, you will be redirected to Log In Page.',
      profileData: 'Your profile data have been updated.',
      changePasswordSuccess: 'Your password has been changed successfully.',
      preferences: 'Your preferences have been changed.',
      disableAccount: 'Your account has been deleted, you will be redirected to Log In Page.',
      confirmEmailSuccess: 'Your email has been confirmed',
      emailResent: 'A new verification email has been sent!',
      emailResetPasswordSuccess: 'A reset-password email has been sent!',
      updateTeamSuccess: 'Your team has been updated successfully!',
      invitationAccepted: 'Invitation successfully accepted!',
      supportMessageSuccess: 'Support message sent successfully!',
    },
    navigation: {
      skip_nav: 'Skip to content',
      page_rows_per_page: 'Rows Per Page',
      page_range_info: 'Range Info',
      next: 'NEXT',
      no_results: 'NO RESULTS',
    },
    action: {
      add: 'Add',
      save: 'Save',
      delete: 'Delete',
      sort: 'SORT',
      add_filter: 'Add Filter',
      add_court: 'Add Court',
      search: 'Search',
      back: 'Back',
      refresh: 'Refresh',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      cancel: 'Cancel',
    },
    tour: {
      didYouKnow: 'Did you know?',
      didYouKnowIntro: '',
      welcome: 'Welcome to Mismatch App',
      welcomeIntro: 'Explore the app to manage your team effectively. Ready to begin?',
      organisation: 'Organisation Section',
      orgIntro:
        'Create and edit organisations, invite other members, see all organisations you are a member of.',
      logo: "Team's Logo and Name",
      logoIntro:
        "Your team's name and logo. Easily revisit this page, or check the calendar, anytime by clicking on your organisation's logo.",
      roster: 'Team Management',
      rosterIntro:
        'Use the calendar to keep track of team events such as practices and games, and manage your <strong>team roster</strong>.',
      rosterMan: 'Roster Management',
      rosterManIntro:
        "Effortlessly manage your team's roster here. Add, edit, or remove players as needed.",
      playerList: 'Player List',
      playerListIntro:
        'All team players listed. Sort by name, jersey, height, age. Click a player to edit details.',
      addPlayer: 'Add Player',
      addPlayerIntro:
        'Click the <strong>Add Player</strong> button to seamlessly integrate new members into your roster.',
    },
  },
  Password: {
    NotAllowedKeys: 'Invalid password',
  },
  GENERAL_SYSTEM_LANGUAGE: 'System Language',
  TEMPORAL_DATE_FORMAT: 'Date Format',
}

export default en
